module.exports = __webpack_public_path__ + "static/media/sale.a4a340be.svg";